import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FiReviewCard from "../../../../components/ui/cards/finances/FiReviewCard";
import BaseCarousel from "../../../../components/ui/carousels/common/BaseCarousel";
import { fetchReviewList } from "../../../../api/reviews/PlaintrReview";

function FiReviews({ content }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadReviews = async () => {
      try {
        const response = await fetchReviewList(
          "/review/plaintr-reviews?service_type=FI&limit=20",
        );
        if (response.ok) {
          const data = await response.json();
          const formattedReviews = (data.reviews || []).map((item) => ({
            id: item.id,
            name: item.user,
            review: item.description,
            rate: item.rate,
            avatar: item.avatar,
          }));
          setReviews(formattedReviews);
        }
      } catch (error) {
        console.error("Error fetching Financial Insights reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    loadReviews();
  }, []);

  if (loading) {
    return null; // Or render a loader/skeleton component here
  }

  if (reviews.length === 0) {
    return null; // Hide review section if no reviews exist yet
  }

  return (
    <div className="fi-review-container">
      <BaseCarousel
        title={content.review_section.heading}
        description={content.review_section.description}
        items={reviews}
        showBorder={false}
        showArrows={true}
        showDots={true}
        containerClassName="fi-review-carousel"
        renderItem={(review) => (
          <FiReviewCard
            key={review.id}
            name={review.name}
            review={review.review}
            rate={review.rate}
            avatar={review.avatar}
          />
        )}
      />

      <div className="cta-container">
        <Link to="/sign-up" className="cta-button primary short">
          {content.review_section.cta_rev}
        </Link>
      </div>
    </div>
  );
}

export default FiReviews;
